import { apiPost, ApiError } from '.';

/**
 * Запрос серий продуктов
 */
function apiWebinar3TestList() {
  return async (page, pageSize, filter, props, sortProp, sortOrder, searchProps) => {
    const { err, errmsg, data } = await apiPost('/webinars3/test/list', {
      collection: 'Webinars3Test',
      role: 0,
      page,
      pageSize,
      filter,
      props,
      sortProp,
      sortOrder,
      schProps: searchProps,
    });
    if (err !== 0) throw ApiError(err, errmsg);
    return data;
  };
}

export default apiWebinar3TestList;
